import { Request } from 'components/Request';

// A stored Discord avatar URL stops working when the player changes avatars.
// When one fails to load, the server looks up the current one (at most once an
// hour per player). One request per player per page, however many of their
// usernames are on it.
const requests = new Map();

export function refreshDiscordAvatar(playerId) {
	if(!playerId) {
		return Promise.resolve(null);
	}
	if(!requests.has(playerId)) {
		requests.set(playerId, Promise.resolve(Request.apiv1('player/refresh_discord_avatar', { player_id: playerId }))
			.then((response) => (response && response.avatar_url) || null)
			.catch(() => null));
	}
	return requests.get(playerId);
}
